<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nSEZpD/tc-custom/9781399098236.jpg?1709609085553" alt="This image is the cover for the book Salvation Army"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Salvation Army
      </h1>
      <p class="bookDescription body article font2">
        <p>In 2015 the Salvation Army celebrated the 150th anniversary of its birth in the poverty and squalor of London’s East End. Today the Army is to be found in towns and cities throughout Britain, its members readily recognized through their military uniform and their reputation for good works widely acknowledged. Many people, however, are unaware of the origins and subsequent development of the organisation. At times Salvationists were imprisoned, beaten up in street riots and ridiculed in the press for their religious beliefs. Despite this persecution the Army put in place a program of help for the poor and marginalised of such ambition that it radically altered social thinking about poverty.  There have been very few attempts at writing a wider and accessible account which locates the Army in its historical context. This is something of an omission given that it has made a unique contribution to the changing social, cultural and religious landscape of Britain. The Salvation Army: 150 years of Blood and Fire aims to provide a history of the organisation for the general reader and is for anyone who is interested in the interplay of people, ideas and events. The book reveals how the story of the Salvation Army raises fundamental questions about issues of power, class, gender and race in modern society; all as pertinent today as they were in Victorian Britain. The Salvation Army: 150 years of Blood and Fire also makes an extensive use of pictures illustrative of the Army’s history gathered from around the world, most of which have never previously been published.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Huggins
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?09c2f89c